// extracted by mini-css-extract-plugin
module.exports = {"container":"Vt","brandName":"Wt","productName":"Xt"};